import type { IStructureTreePoint, TAggregateCheckboxState } from "../types";

export const sortPointsByUserSortNum = <T extends { id: number; userSortNum?: number | null }>(points: T[]): T[] =>
  [...points].sort((left, right) => {
    const leftSortNum = left.userSortNum ?? Number.MAX_SAFE_INTEGER;
    const rightSortNum = right.userSortNum ?? Number.MAX_SAFE_INTEGER;

    if (leftSortNum !== rightSortNum) {
      return leftSortNum - rightSortNum;
    }

    return left.id - right.id;
  });

export const mapPointApiResponse = (row: Record<string, unknown>): IStructureTreePoint => ({
  id: Number(row.id),
  title: String(row.title ?? ""),
  direction: Number(row.Direction ?? row.direction ?? 0),
  userSortNum:
    typeof row.usn === "number" && !Number.isNaN(row.usn)
      ? row.usn
      : typeof row.UserSortNum === "number" && !Number.isNaN(row.UserSortNum)
        ? row.UserSortNum
        : null,
});

export const formatStructureTreePointLabel = (
  point: Pick<IStructureTreePoint, "title" | "direction">,
  formatDirectionLabel: (direction: number) => string,
): string => {
  if (!Number.isFinite(point.direction)) {
    return point.title;
  }

  return `${point.title} ${formatDirectionLabel(point.direction)}`;
};

export const getAggregateCheckboxState = (
  pointIds: readonly number[],
  selectedPointIds: ReadonlySet<number>,
): TAggregateCheckboxState => {
  if (!pointIds.length) {
    return "unchecked";
  }

  const selectedCount = pointIds.filter(pointId => selectedPointIds.has(pointId)).length;

  if (selectedCount === 0) {
    return "unchecked";
  }

  if (selectedCount === pointIds.length) {
    return "checked";
  }

  return "indeterminate";
};
